/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from 'react';
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

function Seo({ pagePath, title, description, author, image, ogType, publishedUtc, children }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            siteName
            title
            description
            author
            image
            siteUrl
            twitterUsername
            shouldCrawlSite
          }
        }
      }
    `
  )

  const seo = {
    siteName: site.siteMetadata?.siteName,
    title: title ? title : site.siteMetadata?.title,
    description: description ? description : site.siteMetadata?.description,
    author: author ? author : site.siteMetadata?.author,
    image: image ? image : site.siteMetadata?.image,
    siteUrl: site.siteMetadata?.siteUrl,
    pagePath: pagePath ? site.siteMetadata?.siteUrl+pagePath : null, // handle canonical if page path provided
    twitterUsername: site.siteMetadata?.twitterUsername,
    shouldCrawlSite: site.siteMetadata?.shouldCrawlSite,
    ogType: ogType ? ogType : 'website',
    publishedUtc: publishedUtc ? publishedUtc : null,
  }
  //console.debug('seo', seo);

  return (
    <>
      <meta name="robots" content={seo.shouldCrawlSite === 'false' ? 'noindex, nofollow' : 'index, follow'} />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="author" content={seo.author} />
      <meta name="image" content={seo.image} />
      <link rel="canonical" href={seo.pagePath ? seo.pagePath : seo.siteUrl} />
      <meta property="og:type" content={seo.ogType} />
      {seo.ogType === 'article' && seo.publishedUtc ?
        <meta property="article:published_time" content={seo.publishedUtc} />
      :
        null
      }
      <meta property="og:site_name" content={seo.siteName} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.pagePath ? seo.pagePath : seo.siteUrl} />
      <meta property="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={seo.twitterUsername} />
      <meta name="twitter:creator" content={seo.twitterUsername} />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:url" content={seo.pagePath ? seo.pagePath : seo.siteUrl} />
      <meta name="theme-color" content="#1A95D5" media="(prefers-color-scheme: light)" />
      <meta name="theme-color" content="#1A95D5" media="(prefers-color-scheme: dark)" />
      {children}
    </>
  )
}

Seo.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  pagePath: PropTypes.string,
  image: PropTypes.string,
  ogType: PropTypes.string,
  publishedUtc: PropTypes.string,
}

export default Seo
